export const slugifyProductName = (name) => {
  const normalized = String(name || "product")
    .normalize("NFKD")
    .replace(/&/g, " and ")
    .replace(/['’]/g, "")
    .replace(/[^a-zA-Z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .toLowerCase();

  return normalized || "product";
};

export const getProductSlug = (product, products = []) => {
  const baseSlug = slugifyProductName(product?.name);
  const matchingProducts = products.filter((item) => (
    slugifyProductName(item?.name) === baseSlug
  ));

  if (matchingProducts.length > 1 && product?.id !== undefined) {
    return `${baseSlug}-${product.id}`;
  }

  return baseSlug;
};

export const getProductPath = (product, products = []) => (
  /^\/store\/[a-z0-9-]+$/.test(product?.path || '') ? product.path : `/store/${getProductSlug(product, products)}`
);

const decodeRouteParam = (value) => {
  try {
    return decodeURIComponent(String(value || ""));
  } catch (error) {
    return String(value || "");
  }
};

export const isLegacyProductIdParam = (value) => /^\d+$/.test(decodeRouteParam(value));

export const findProductByRouteParam = (products = [], routeParam) => {
  const decodedParam = decodeRouteParam(routeParam);

  if (isLegacyProductIdParam(decodedParam)) {
    const productId = Number(decodedParam);
    return products.find((product) => Number(product.id) === productId) || null;
  }

  return products.find((product) => (
    (product.slug || getProductSlug(product, products)) === decodedParam
  )) || null;
};
